import t_05_2331_b from './KZ.T.05.2331 black.svg'
import t_05_2331 from './KZ.T.05.2331.svg'

// import t_05_0294 from './t_05_0294.png'

export default [
  t_05_2331,
  t_05_2331_b
]
